'use strict';

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _BasicPresence = require('./BasicPresence');

var _BasicPresence2 = _interopRequireDefault(_BasicPresence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Presence = function () {
    function Presence() {
        (0, _classCallCheck3.default)(this, Presence);
    }

    (0, _createClass3.default)(Presence, [{
        key: 'get',
        value: function get() {
            if (!this.presenceInstance) {
                this.init();
            }
            return this.presenceInstance;
        }
    }, {
        key: 'setPresenceProvider',
        value: function setPresenceProvider(provider) {
            this.PresenceProvider = provider;
            if (this.presenceInstance) {
                this.init();
            }
        }
    }, {
        key: 'init',
        value: function init() {
            var _PresenceProvider = this.PresenceProvider,
                PresenceProvider = _PresenceProvider === undefined ? _BasicPresence2.default : _PresenceProvider;


            this.presenceInstance = new PresenceProvider();
        }
    }]);
    return Presence;
}();

if (global.mxPresence === undefined) {
    global.mxPresence = new Presence();
}

module.exports = global.mxPresence;
//# sourceMappingURL=Presence.js.map